/**
 * Quiz content validator
 * Validates quiz data for required fields
 */

import type { ContentValidator, ValidationResult } from '@ai-content-hub/content-core';
import type { QuizData } from './schema';

export const quizValidator: ContentValidator<QuizData> = {
    validate(data: QuizData): ValidationResult {
        const errors: ValidationResult['errors'] = [];

        if (!data?.title?.trim()) {
            errors.push({ field: 'title', message: 'Quiz title is required.' });
        }

        const items = data?.items ?? [];
        if (items.length === 0) {
            errors.push({ field: 'items', message: 'At least one quiz item is required.' });
        }

        return { isValid: errors.length === 0, errors };
    },
};
